var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerFlagEnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 36",
    style: {
      enableBackground: "new 0 0 28 36"
    },
    xmlSpace: "preserve",
    width: 28,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,1C7.6,1,1,6.1,1,14.5c0,2.1,0.7,4.3,1.8,6.5c1,2.2,2.4,4.3,3.8,6.3c2.8,3.8,5.6,6.8,5.8,7 c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.1,0.6,0.2,0.9,0.2s0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.5c0.2-0.2,3-3.2,5.8-7 c1.4-1.9,2.8-4.1,3.8-6.3c1-2.2,1.8-4.4,1.8-6.5C27,6.1,20.4,1,14,1z",
    fill: "#036BA5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.1,
    r: 10.1,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,12.8l1.7-4.4H10.3c0-0.5-0.3-0.9-0.9-0.9c-0.5,0-0.9,0.3-0.9,0.9v12.2c0,0.5,0.3,0.9,0.9,0.9 c0.5,0,0.9-0.3,0.9-0.9v-3.5h10.4L19,12.8z",
    fill: "#036BA5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerFlagEnd);
export default __webpack_public_path__ + "static/media/markerFlagEnd.ea99f750774ddeedf7ecfb746d558037.svg";
export { ForwardRef as ReactComponent };